// Route → page-title table for the shell breadcrumb fallback
// (`AppShell.pageTitle`). This is NOT a nav rail: primary nav is the caller's
// vaults list in the sidebar, and the role-gated destinations (Users/Server)
// live in the footer user popover, gated inline there via `hasServerRole`
// (see AppShell + decisions/90). This table carries no roles and no icons —
// it only supplies a human title when a content-area route has no breadcrumb.

export interface NavRoute {
  label: string;
  path: string;
}

/** Content-area routes that need a human title in the breadcrumb. */
export const NAV_ROUTES: NavRoute[] = [
  { label: "Vaults", path: "/vaults" },
  { label: "Users", path: "/users" },
  { label: "Server", path: "/server" },
  { label: "Docs", path: "/docs" },
];
